var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-layout" },
    [
      _c("swb-query-sort-area", {
        ref: "query_model",
        attrs: {
          config: _vm.queryConfig,
          queryKey: _vm.queryKey,
          queryOnLoad: false,
          queryHandler: _vm.queryHandler
        }
      }),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.staffList, border: "" },
          on: { "current-change": _vm.handleCurrentChange }
        },
        [
          _c("el-table-column", {
            attrs: { width: "40" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "copy-radio",
                        class: {
                          circle:
                            _vm.staffInfo != null &&
                            _vm.staffInfo.id == rows.row.id
                        }
                      },
                      [_c("div", { staticClass: "circle-dot" })]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "left", prop: "comName", label: "公司名称" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "left",
              prop: "name",
              label: "员工名称",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    _c("span", [_vm._v(_vm._s(rows.row.name))]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-red" }, [
                      _vm._v(_vm._s(rows.row.disabled ? "【禁】" : ""))
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { align: "center", label: "已订阅", width: "60" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.isSubscr
                      ? _c("span", { staticClass: "font-green" }, [
                          _vm._v("是")
                        ])
                      : _c("span", { staticClass: "font-red" }, [_vm._v("否")])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "100",
              prop: "phoneNo",
              label: "用户手机"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "170",
              prop: "idCertNo",
              label: "身份证号"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              align: "center",
              width: "100",
              prop: "contactTel",
              label: "联系电话"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.totalCount > 10
        ? _c(
            "div",
            { staticClass: "pagination-layout mt10" },
            [
              _c("el-pagination", {
                staticClass: "pagination-layout mt10",
                attrs: {
                  background: "",
                  "page-size": _vm.pageSize,
                  "page-sizes": _vm.pageSizes,
                  "current-page": _vm.pageNumber,
                  total: _vm.totalCount,
                  layout: "prev, pager, next, jumper, sizes, total"
                },
                on: {
                  "current-change": _vm.handlePageChange,
                  "size-change": _vm.handleSizeChange
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58361bf1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58361bf1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ComStaffForSelect.vue
// module id = 1912
// module chunks = 1